import React from 'react'
import withFormState from 'src/components/aciacehighway/hocs/withFormState';
import { ScopedCssBaseline } from '@mui/material';
import EditEntrySummary from '../component/entry-form/edit/EditEntrySummary';

// const fullTitle = 'Entry Summary Details';
// const shortTitle = 'Details';
// const BCrumb = [
//   { title: "ABI" },
//   { title: "Entry Summary", to: pathMap.ABI_ENTRY_SUMMARY_LIST_VIEW },
//   { title: shortTitle, },
// ];


function EditPage({ history, match: { params } }) {

  return (<ScopedCssBaseline>

    <EditEntrySummary isEntrySummary id={params.id} />
  </ScopedCssBaseline>);
}

export default withFormState(EditPage)
